enum Constant {
  HEADER_TOKEN_NAME = 'authorization', // token设置在header中的名称
  LOGIN_KEY = 'loginInfo', // 登录信息保存在缓存中的key
  CURRENT_PAGE_KEY = 'currentPage', // 当前所在菜单key
  SENCE_ID = 'senceId', // 场景ID
  VERIFY_KEY = 'verifyKey', // 验证key
}
export default Constant;


// WEBPACK FOOTER //
// ./src/dataModel/Constant.ts